<template>
    <div>
        <div class="scrollable-pane">
            <div class="scrollable-pane-content">
                <h2>{{t.title}}</h2>
                <table class="edit-table">
                    <tbody>
                    <tr>
                        <th><label for="hide_mapped_continue_reasons">{{t.hide_mapped_continue_reasons}}</label></th>
                        <td><input type="checkbox" id="hide_mapped_continue_reasons" v-model="hideContinue"></td>
                    </tr>
                    <tr>
                        <th><label for="hide_mapped_end_reasons">{{t.hide_mapped_end_reasons}}</label></th>
                        <td><input type="checkbox" id="hide_mapped_end_reasons" v-model="hideEnd"></td>
                    </tr>
                    <tr>
                        <th><label for="lock_continue_reason_id">{{t.lock_continue_reason_id}}</label></th>
                        <td><select id="lock_continue_reason_id" v-model="lockContinueReason">
                            <option value="">{{t.option_no_lock}}</option>
                            <option
                                    v-for="reason in continueReasons"
                                    :value="reason.id"
                            >
                                {{reason.name}}
                            </option>
                        </select></td>
                    </tr>
                    <tr>
                        <th><label for="lock_end_reason_id">{{t.lock_end_reason_id}}</label></th>
                        <td><select id="lock_end_reason_id" v-model="lockEndReason">
                            <option value="">{{t.option_no_lock}}</option>
                            <option
                                    v-for="reason in endReasons"
                                    :value="reason.id"
                            >
                                {{reason.name}}
                            </option>
                        </select></td>
                    </tr>
                    <tr>
                        <th><label for="custom_fields_to_display">{{t.custom_fields_to_display}}</label></th>
                        <td>
                            <div id="custom_fields_to_display" v-for="field in customFields">
                                <label><input
                                        type="checkbox"
                                        :value="field.id"
                                        :checked="field.checked"
                                        v-model="checkedFields"
                                >{{field.name}}</label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th><label for="open_website_url">{{t.open_website_url}}</label></th>
                        <td><input type="checkbox" id="open_website_url" v-model="openUrl"></td>
                    </tr>
                    <tr>
                        <th><label for="auto_open_order">{{t.auto_open_order}}</label></th>
                        <td><input type="checkbox" id="auto_open_order" v-model="autoOpenOrder"></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="corner-commit-actions">
            <button class="action-save-button" @click="onSave">{{i18n('save')}}</button>
        </div>
    </div>

</template>

<script>

    import axios from 'axios';
    import App from '../../App.js';
    import {t} from '../../i18n/i18n.js';
    import MessagePopupView from "../../../controls/MessagePopupView.js";

    import {keyValueToObject, objectToKeyValue} from '../../../appHelpers/KeyValueConverter.js';

    let initialSnapshot = '';

    export default {
        name: 'ProjectAdvancedSettings',
        props: ['projectId', 'bb'],
        data() {
            return {
                continueReasons: [],
                endReasons: [],
                hideContinue: false,
                hideEnd: false,
                lockContinueReason: '',
                lockEndReason: '',
                openUrl: false,
                autoOpenOrder: false,
                customFields: [],
                checkedFields: [],
                advancedSettings: [],
                t: t('project_advanced_settings'),
                i18n: t,
            }
        },
        computed: {},
        mounted() {
            if (!this.projectId) return;
            this.getPageData(this.projectId);
        },
        updated() {

            if (JSON.stringify(this.$data) === initialSnapshot) {
                return; // This is the first update after fetching page data.
            }

            this.bb._saveNeeded = true;

        },
        methods: {
            async getPageData(projectId) {

                const dataUrls = {
                    endReasons: 'end_reasons',
                    continueReasons: 'continue_reasons',
                    customFields: 'contact_custom_fields',
                    advancedSettings: 'advanced_settings'
                };

                const requests = Object.values(dataUrls)
                    .map(dataUrl =>
                        axios.get(App.apiUrl(`projects/${projectId}/${dataUrl}`)));

                try {

                    const results = await Promise.all(requests);

                    Object.keys(dataUrls)
                        .forEach((urlKey, resultIndex) =>
                            this[urlKey] = results[resultIndex].data);

                    const settings = keyValueToObject(this.advancedSettings);

                    this.hideEnd = settings.hide_mapped_end_reasons;
                    this.hideContinue = settings.hide_mapped_continue_reasons;
                    this.lockContinueReason = settings.lock_continue_reason_id;
                    this.lockEndReason = settings.lock_end_reason_id;
                    this.openUrl = settings.open_url;
                    this.autoOpenOrder = settings.auto_open_order;
                    this.checkedFields = settings.custom_fields_to_display
                        && settings.custom_fields_to_display.length
                        && settings.custom_fields_to_display.split(',') || [];

                    initialSnapshot = JSON.stringify(this.$data);

                } catch (err) {

                    App.showXhrError(err.request, err);

                }

            },
            async onSave() {

                const data = {
                    'hide_mapped_end_reasons': this.hideEnd ,
                    'hide_mapped_continue_reasons': this.hideContinue,
                    'lock_continue_reason_id': this.lockContinueReason,
                    'lock_end_reason_id': this.lockEndReason,
                    'custom_fields_to_display': this.checkedFields,
                    'open_url': this.openUrl,
                    'auto_open_order': this.autoOpenOrder,
                };

                const rows = objectToKeyValue(data);

                App.AlertUI.showLoader(t('activity_indicator.saving'));

                try {

                    await axios.post(App.apiUrl(`projects/${this.projectId}/advanced_settings`), {rows});

                    this.bb._saveNeeded = false;

                    new MessagePopupView({addClass: 'done', message: this.t.saved_prompt, queue: true, dismissAfter: 2000}).show();

                } catch (err) {

                    App.showXhrError(err.request, err);

                }

                App.AlertUI.hideLoader();

            }
        },
    }

</script>
